export default function ActivityDeals({setData, form, deals}) {

    if (!form?.activity) {
        return (<>Choose an activity</>)
    }

    const getContent = (item) => {
        let separatedLines = item.description.match(/[^\r\n]+/g);

        if (separatedLines == null) {
            return (item.description);
        }

        return (
            <ul>
                {getLiTags(separatedLines)}
            </ul>
        )
    }
    const getLiTags = (separatedLines) => {
        return (
            separatedLines.map((e, key) => {
                return (
                    <li key={'liline_' + key}>
                        {e}
                    </li>
                )
            })
        )
    }

    return (
        deals[form?.activity].map((item) => {
            let className = form?.deal === item.id ? 'deal_item_selected' : 'deal_item';

            return (
                <div className={className} key={'deal_' + item.id} onClick={() => setData({
                    deal: item.id,
                    dealPrice: item.price,
                    extra: [],
                    extraPrice: [],
                    extraPriceAtt: []
                })}>
                    <h4>{item.name}</h4>
                    <div className={'price'}>{item.price} CHF</div>
                    <div>
                        {getContent(item)}
                    </div>
                </div>
            );
        })
    );
}

